import { get } from "utils"

const getImageSrcBasedOnOptions = (
  display360,
  options,
  activeOption,
  step,
  isSelectColorInterior
) => {
  let finalImageSrc = ""
  const getTransmissionName = get("transmission.name", options)
  const getFuelType = get("engine.fuelType", options)
  if (isSelectColorInterior) {
    // If it is select INTERIOR color screen, use the fallback options
    if (getTransmissionName === "Manual") {
      if (getFuelType === "Diesel" && activeOption.dieselManualSrc) {
        finalImageSrc = activeOption.dieselManualSrc
      } else {
        finalImageSrc = activeOption.manualImageSrc
      }
    } else if (getTransmissionName === "Auto") {
      if (getFuelType === "Diesel" && activeOption.dieselAutoSrc) {
        finalImageSrc = activeOption.dieselAutoSrc
      } else {
        finalImageSrc = activeOption.autoImageSrc
      }
    }
  } else {
    // If it is EXTERIOR color image, check to see if it is "SELECT A GRADE" step
    if (step.radioGroup[0].groupName === "grades" && options.color) {
      // Check if there's any pre-selected color that persists, use that otherwise fall back to default.
      if (options.color) {
        finalImageSrc = options.color.imageSrc
      } else {
        for (const color of options.colors) {
          if (color.default) {
            finalImageSrc = color.imageSrc
          }
        }
      }
    } else {
      // If it is not "SELECT A GRADE" step, use the active option image, otherwise fall back to default
      finalImageSrc =
        display360 && Array.isArray(activeOption.imageSrc360) && activeOption.imageSrc360.length > 0
          ? activeOption.imageSrc360
          : activeOption.imageSrc || options.color.imageSrc
    }
  }
  return finalImageSrc
}

export default getImageSrcBasedOnOptions



// WEBPACK FOOTER //
// ./src/containers/configured-vehicle-selector/get-image-src-based-on-options.jsx